import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { apiResponse } from '../../models/apiResponse';
import { SchoolResponse } from '../../models/schools/schoolResponse';
import { Observable, ObservableLike } from 'rxjs';
import { ListSchoolRequest } from '../../models/schools/listSchoolRequest';
import { ListSchoolNameBySearchTextResponse } from '../../models/schools/listSchoolNameBySearchTextResponse';
import { RegisterSchoolRequest } from '../../models/schools/registerSchoolRequest';
import { UpdateSchoolRequest } from '../../models/schools/updateSchoolRequest';
import { RegisterSchoolAdminRequest } from '../../models/schools/registerSchoolAdminRequest';
import { SchoolAdminResponse } from '../../models/schools/schoolAdminResponse';
import { SchoolStudentResponse } from '../../models/schools/schoolStudentResponse';
import { RegisterSchoolStudentRequest } from '../../models/schools/registerSchoolStudentRequest';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ImportSchoolStudentRequest } from '../../models/schools/importSchoolStudentRequest';
import { ImportSchoolStudentResponse } from '../../models/schools/importSchoolStudentResponse';
import { StudentListForSuperAdminRequest } from '../../models/super-admin/studentListForSuperAdminRequest';
import { StudentExportColumnRequest, StudentExportPreferences } from '../../models/super-admin/studentExportColumnRequest';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  constructor(private genericService: GenericService, private http: HttpClient) { }

  listSchools(listSchoolRequest:ListSchoolRequest):Observable<apiResponse<SchoolResponse[]>>
  {
    return this.genericService.post(`schoollist`,listSchoolRequest);
  }
  listSchoolNameBySearchText(searchtext: string):Observable<apiResponse<ListSchoolNameBySearchTextResponse[]>>
  {
    return this.genericService.get(`school/search/${searchtext}`);
  }
  registerSchool(registerSchoolRequest:RegisterSchoolRequest): Observable<SchoolResponse>
  {
    return this.genericService.post(`school`, registerSchoolRequest);
  }
  registerSchoolAdmin(registerSchoolAdminRequest: RegisterSchoolAdminRequest): Observable<SchoolAdminResponse>
  {
    return this.genericService.post(`schooladmin`, registerSchoolAdminRequest);
  }
  registerSchoolStudent(registerSchoolStudentRequest: RegisterSchoolStudentRequest):Observable<SchoolStudentResponse>
  {
    return this.genericService.post(`school/student`, registerSchoolStudentRequest);
  }
  updateSchoolStatus(id: number): Observable<SchoolResponse>
  {
    return this.genericService.patch(`school/${id}`, {});
  }
  updateSchoolStudentStatus(studentId: number):Observable<SchoolStudentResponse>
  {
    return this.genericService.patch(`school/student/${studentId}`,{});
  }
  updateSchoolDetails(updateSchoolRequest: UpdateSchoolRequest): Observable<SchoolResponse>
  {
    return this.genericService.put(`school`, updateSchoolRequest);
  }
  getSchoolAdminById(id: number): Observable<SchoolAdminResponse>
  {
    return this.genericService.get(`school/admin/${id}`);
  }
  downloadSampleExcelForStudentImport():Observable<HttpResponse<ArrayBuffer>>
  {
    return this.genericService.getBinary(`download/excel/student/import`)
  }
  importSchoolStudents(req: ImportSchoolStudentRequest[]):Observable<ImportSchoolStudentResponse>
  {
    return this.genericService.post(`school/student/import`, req);
  }
  downloadSudentListOnSuperAdmin(req: StudentListForSuperAdminRequest): Observable<HttpResponse<ArrayBuffer>>
  {
    return this.genericService.getBinaryPost(`download/superadmin/student/list`, req);
  }

  downloadCustomStudentListOnSuperAdmin(req: StudentExportColumnRequest): Observable<HttpResponse<ArrayBuffer>>
  {
    return this.genericService.getBinaryPost(`download/superadmin/student/list/custom`, req);
  }
}
